import { render, staticRenderFns } from "./entrevista.vue?vue&type=template&id=0c424fb2"
import script from "./entrevista.vue?vue&type=script&lang=js"
export * from "./entrevista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports